import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { formatEncodingExceptionqalxwmlsg11w as formatEncodingException } from './internal/JsonExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var JsonDecodingExceptionClass;
function JsonDecodingException() {
  if (JsonDecodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(fullMessage, shortMessage, offset, path, input, hint) {
        return new.target.l2p(fullMessage, shortMessage, offset, path, input, hint);
      }
      static l2p(fullMessage, shortMessage, offset, path, input, hint) {
        var $this = this.b2q(fullMessage);
        captureStack($this, $this.k2p_1);
        $this.f2p_1 = shortMessage;
        $this.g2p_1 = offset;
        $this.h2p_1 = path;
        $this.i2p_1 = input;
        $this.j2p_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonDecodingException');
    JsonDecodingExceptionClass = $;
  }
  return JsonDecodingExceptionClass;
}
var JsonExceptionClass;
function JsonException() {
  if (JsonExceptionClass === VOID) {
    class $ extends SerializationException() {
      static b2q(message) {
        var $this = this.c1o(message);
        captureStack($this, $this.a2q_1);
        $this.z2p_1 = message;
        delete $this.message;
        return $this;
      }
      r() {
        return this.z2p_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'JsonException');
    JsonExceptionClass = $;
  }
  return JsonExceptionClass;
}
var JsonEncodingExceptionClass;
function JsonEncodingException() {
  if (JsonEncodingExceptionClass === VOID) {
    class $ extends JsonException() {
      constructor(shortMessage, classSerialName, hint) {
        return new.target.m2q(shortMessage, classSerialName, hint);
      }
      static m2q(shortMessage, classSerialName, hint) {
        classSerialName = classSerialName === VOID ? null : classSerialName;
        hint = hint === VOID ? null : hint;
        var $this = this.b2q(formatEncodingException(shortMessage, hint));
        captureStack($this, $this.l2q_1);
        $this.i2q_1 = shortMessage;
        $this.j2q_1 = classSerialName;
        $this.k2q_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'JsonEncodingException');
    JsonEncodingExceptionClass = $;
  }
  return JsonEncodingExceptionClass;
}
//region block: exports
export {
  JsonDecodingException as JsonDecodingExceptionoyag1psadwuw,
  JsonEncodingException as JsonEncodingException3vzv9k0f9l05u,
};
//endregion

//# sourceMappingURL=JsonExceptions.mjs.map
